import Breadcrumb from '../components/Breadcrumb';
import { useParams } from 'react-router-dom';
import { useFetch } from '../hook/useFecth';
import ViewClienteLayer from '../components/ViewClienteLayer';

function Edit({ id }) {
    const { data, mutate } = useFetch(`cliente/${id}`);
    return <ViewClienteLayer data={data} mutate={mutate} backTo="/clientes" />;
}

function Layer() {
    const { id } = useParams();

    if (id) return <Edit id={id} />;

    return <ViewClienteLayer backTo="/clientes" />;
}

const ClientesPage = () => {
    const { id } = useParams();

    return (
        <>
            <Breadcrumb
                title={!Boolean(id) ? 'Cadastrar - Cliente' : 'Editar - Cliente'}
                icon={!Boolean(id) ? 'solar:user-plus-outline' : 'solar:user-check-outline'}
            />
            <Layer />
        </>
    );
};

export default ClientesPage;
